import type { ReactNode } from 'react';

import { cn } from '@virginexperiencedays/tailwind';

import { DisplayHeading } from '../../../typography/DisplayHeading';

export type OverviewProps = {
  className?: string;
  dataTestId?: string;
  children: string | ReactNode;
  heading?: string;
  headingSize?: '1' | '2' | '3' | '4' | '5' | '6';
  headingSEOOverride?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

export const Overview = ({
  className,
  children,
  headingSEOOverride,
  dataTestId = 'overview',
  heading = 'Overview',
  headingSize = '3',
}: OverviewProps) => {
  return (
    <div data-testid={dataTestId} className={cn('mt-10 flex flex-col', className)}>
      <DisplayHeading
        className="text-neutral-strong text-xl"
        data-testid="overview-title"
        size={headingSize}
        as={headingSEOOverride}
      >
        {heading}
      </DisplayHeading>
      <div
        className="text-neutral [&_a]:text-neutral [&_a]:focus:text-neutral [&_a]:hover:text-neutral [&_a]:underline"
        data-testid="overview-description"
      >
        {children}
      </div>
    </div>
  );
};
